module.exports = __webpack_public_path__ + "img/shark.be5030ca.webp";